import { toast } from "../apis/request";

export const successHandling = (t, successfulText) => {
  return toast.success(t(successfulText));
  //window.history.back()
};
